<section class="outer_seo_page_component_container">
  <section class="meet_hh_container">
    <div class="meet_hh_container">
      <div class="title_outer_container inner_seo_page_component_container">
        <div class="user-title">
          <h2>{{ 'PAGES.LANDING.COMMUNITY_1' | translate }}</h2>

          <p>
            {{
              'PAGES.LANDING.COMMUNITY_2'
                | translate
                  : { handyhanders: (statistics().handyhanders | number)! }
            }}
          </p>
        </div>
      </div>
    </div>
    <div class="carousel_container">
      @if (showLeftArrow()) {
        <button class="scroll-arrow scroll-arrow-left" (click)="scrollLeft()">
          <mat-icon>chevron_left</mat-icon>
        </button>
      }
      <div
        class="absolute_carousel_container"
        #carouselContainer
        (scroll)="checkScrollArrows()"
      >
        <div class="absolute_carousel">
          @for (hh of handyhanders; track $index) {
            <div>
              <article class="hh_wrapper" [class.first_element]="$first">
                <!--
                  Both slots always render; CSS picks one per breakpoint. Do not
                  gate them on a viewport flag — the server cannot know the
                  viewport, so the SSR markup would be wrong until hydration.
                -->
                <div class="hhImg hhImg--desktop">
                  <img
                    [width]="270"
                    [height]="320"
                    loading="lazy"
                    [src]="hh.imageSrc"
                    class="actual_pp_img"
                    [alt]="
                      hh.name ||
                      ('PAGES.LANDING.HH_PROFILE_IMG_ALT' | translate)
                    "
                  />
                </div>

                <div class="info_section_pp">
                  <div class="head_of_hh_card">
                    <div class="hhImg hhImg--mobile">
                      <img
                        [width]="270"
                        [height]="320"
                        [alt]="
                          hh.name ||
                          ('PAGES.LANDING.HH_PROFILE_IMG_ALT' | translate)
                        "
                        [src]="hh.imageSrc"
                        loading="lazy"
                        class="actual_pp_img"
                      />
                    </div>

                    <div class="name_and_trust">
                      <div>
                        <p class="name">{{ hh.name }}</p>
                      </div>

                      <div class="trustGroup">
                        <div class="trust_inner_container">
                          <div class="stardiv rates_number_container">
                            <div class="star_div">
                              <img
                                class="star"
                                [width]="20"
                                [height]="20"
                                [src]="starIcon"
                                style="width: auto"
                                loading="lazy"
                                alt="Rating star"
                              />
                            </div>
                            <p class="number_p">{{ hh.trustRating }}</p>
                          </div>

                          <div class="rates_text_container">
                            <p class="minor_headline">
                              {{ 'PAGES.VERTICAL.REVIEWS' | translate }} ({{
                                hh.reviewGiven
                              }})
                            </p>
                          </div>
                        </div>

                        <div class="trust_inner_container">
                          <div class="rates_number_container">
                            <div class="deal_badge_div">
                              <img
                                class="deal_badge"
                                [width]="26"
                                [height]="26"
                                [src]="dealBadge"
                                style="width: auto"
                                loading="lazy"
                                alt="Rating star"
                              />
                            </div>
                            <p class="number_p">{{ hh.completionRate }}%</p>
                          </div>

                          <div class="rates_text_container">
                            <p class="minor_headline">
                              {{ 'GENERAL.COMPLETION_RATE' | translate }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="specialities_container">
                    <p class="specialities">
                      {{ hh.specialityTranslationKey | translate }}
                    </p>
                  </div>

                  <div class="description">
                    <p>{{ hh.userDescriptionKey | translate }}</p>
                  </div>

                  <div class="profile_traits_container">
                    <div class="profile_traits">
                      @for (badge of hh.badges; track $index) {
                        <div class="badge_container">
                          <img
                            class="badge"
                            [width]="badge.width"
                            [height]="badge.height"
                            loading="lazy"
                            [src]="badge.src"
                            [alt]="badge.alt"
                          />

                          <p>{{ badge.alt }}</p>
                        </div>
                      }
                    </div>

                    <div class="profile_traits first">
                      <div>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="25"
                          height="18"
                          viewBox="0 0 25 18"
                          fill="none"
                        >
                          <path
                            d="M9.11719 2.7168C8.10742 3.25391 7.30176 3.72656 6.7002 4.13477C6.09863 4.54297 5.59375 5.05859 5.18555 5.68164C4.79883 6.30469 4.60547 7.05664 4.60547 7.9375C4.92773 8.41016 5.30371 8.78613 5.7334 9.06543C6.18457 9.34473 6.73242 9.53809 7.37695 9.64551C9.63281 10.0537 10.7607 11.2676 10.7607 13.2871C10.7607 14.4902 10.3418 15.4893 9.50391 16.2842C8.66602 17.0791 7.58105 17.4766 6.24902 17.4766C5.11035 17.4766 4.10059 17.1973 3.21973 16.6387C2.33887 16.0801 1.65137 15.2959 1.15723 14.2861C0.68457 13.2764 0.448242 12.127 0.448242 10.8379C0.448242 9.26953 0.791992 7.7334 1.47949 6.22949C2.18848 4.7041 3.20898 3.4043 4.54102 2.33008C5.87305 1.25586 7.43066 0.557617 9.21387 0.235352C9.81543 0.729492 10.2021 1.33105 10.374 2.04004L9.11719 2.7168ZM22.8135 2.7168C21.8037 3.25391 20.998 3.72656 20.3965 4.13477C19.7949 4.54297 19.29 5.05859 18.8818 5.68164C18.4951 6.30469 18.3018 7.05664 18.3018 7.9375C18.9033 8.86133 19.8271 9.43066 21.0732 9.64551C23.3076 10.0537 24.4248 11.2676 24.4248 13.2871C24.4248 14.4902 24.0059 15.4893 23.168 16.2842C22.3516 17.0791 21.2773 17.4766 19.9453 17.4766C18.8066 17.4766 17.7969 17.1973 16.916 16.6387C16.0352 16.0801 15.3477 15.2959 14.8535 14.2861C14.3809 13.2764 14.1445 12.127 14.1445 10.8379C14.1445 9.26953 14.4883 7.7334 15.1758 6.22949C15.8848 4.7041 16.9053 3.4043 18.2373 2.33008C19.5693 1.25586 21.127 0.557617 22.9102 0.235352C23.5117 0.729492 23.8984 1.33105 24.0703 2.04004L22.8135 2.7168Z"
                            fill="#1B9AC6"
                          />
                        </svg>

                        <p class="review">
                          {{ hh.reviewTranslationKey2 | translate }}
                        </p>

                        <p class="review_giver">-{{ hh.reviewGiver }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </article>
            </div>
          }
        </div>
      </div>
      @if (showRightArrow()) {
        <button class="scroll-arrow scroll-arrow-right" (click)="scrollRight()">
          <mat-icon>chevron_right</mat-icon>
        </button>
      }

      <div class="blue_backdrop"></div>
    </div>
  </section>
</section>
